<template>
  <div>
    <a-spin tip="Your document is being processed, do not leave this page!" :spinning="loading.page">
      <a-config-provider :locale="getLocalConfigProvider()">
        <div class="wrapper">
          <div class="wrapper-header">
            <span>
              <a-icon type="pic-center" class="margin-right-small" />
              Master COA
            </span>
            <a-button-group>
              <a-button type="primary" @click="handletoCreate('Create', null)" icon="plus"
                :loading="loading.create">&nbsp;Create</a-button>
              <a-button @click="handleReloadpage" icon="reload"></a-button>
            </a-button-group>
          </div>
          <div class="wrapper-body">
            <a-card>
              <a-row :gutter="12">
                <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                  <a-input-search v-model="search" @change="moresearch" placeholder="Quick Search" />
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 0 }">
                  <div style="width:100%;text-align:right">
                    <!-- <a-badge :dot="showbadge">
                      <a-button
                        :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
                        @click="handleshowMore"
                        class="m-width-full"
                        :class="getScreen ? 'margin-top m-width-full' : 'm-width-full'"
                        >{{
                          advancedsearch == "display:none" ? "More" : "Less"
                        }}</a-button
                      >
                    </a-badge> -->
                  </div>
                </a-col>
              </a-row>
              <a-table :rowKey="(record, index) => { return index.toString(); }" size="small" bordered
                :scroll="{ x: 600 }" :columns="columns" :dataSource="resources" :loading="loading.table"
                :pagination="pagination" class="margin-top">

                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{
                    (pagination.page - 1) * pagination.pageSize + index + 1
                  }}</span>
                </template>
                <template slot="kodecoa" slot-scope="data">
                  {{ data.kode_coa }}
                </template>
                <template slot="namacoa" slot-scope="data">
                  {{ data.nama_coa }}
                </template>
                <template slot="parentcoa" slot-scope="data">
                  {{ data.kode_parent_coa }} <br /> {{ data.nama_parent_coa }}
                </template>
                <template slot="tipe" slot-scope="data">
                  {{ data.isdebet == "1" ? "Debit" : "Credit" }}
                </template>
                <template slot="active" slot-scope="data">
                  <a-checkbox :checked="data.aktif_sts == '1' ? true : false"
                    @click="handletoEdit(data.coa_id, data.aktif_sts)"></a-checkbox>
                </template>
                <template slot="note" slot-scope="data">
                  {{ data.note }}
                </template>
                <template slot="action" slot-scope="data">
                  <a-button-group>
                    <a-button icon="edit" :disabled="loading.key == data.coa_id && loading.delete"
                      :loading="loading.key == data.coa_id && loading.edit"
                      @click="handletoCreate('Edit', data.coa_id)"></a-button>
                    <a-button icon="close" :loading="loading.key == data.coa_id && loading.delete" type="danger"
                      @click="handletoDel(data.coa_id)"></a-button>
                  </a-button-group>
                </template>
              </a-table>
            </a-card>
          </div>
        </div>
      </a-config-provider>
    </a-spin>

    <a-modal v-if="modal.edit" v-model="modal.edit" :maskClosable="false" @cancel="handleMeditClose" @ok="handleMeditOk"
      :confirmLoading="loading.saveeditsts" okText="Submit" cancelText="Cancel">
      <template slot="title">
        Edit Status
        <span class="snonaktif" v-if="modal.source.status == '0'">NON ACTIVE</span>
        <span class="saktif" v-else>ACTIVE</span>
        to
        <span class="snonaktif" v-if="modal.source.status == '1'">NON ACTIVE</span>
        <span class="saktif" v-else>ACTIVE</span>
      </template>
      <a-form-model ref="editStsForm" :model="formEditSts" :rules="modal.rules">
        <a-form-model-item ref="note" label="Note" prop="note">
          <a-textarea v-model="formEditSts.note" @blur="() => {
            $refs.note.onFieldBlur();
          }
            " />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-if="modal.create" v-model="modal.create" :maskClosable="false" @cancel="handleMcreateClose"
      @ok="handleMcreateOk" okText="Submit" cancelText="Cancel" :confirmLoading="loading.savecreate">
      <template slot="title">{{ modal.source.mode }} COA</template>
      <a-form :form="formCreate">
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            COA parent :
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
            <a-form-item>
              <!-- <a-select showSearch v-decorator="['coa_parent', { rules: [{ required: true }] }]"
                :filter-option="filterOption">
                <a-select-option v-for="item in mastercoa.coa_parent" :key="item.coa_id">{{ item.text }}</a-select-option>
              </a-select> -->
              <v-select class="m-select" :clearable="true" @input="inputVselect" :options="mastercoa.coa_parent"
                v-decorator="['coa_parent', { rules: [{ required: false }], initialValue: modal.source.data.optionPrn }]"
                placeholder="Select COA Parent" label="text"></v-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <span class="ant-form-item-required">COA Code :</span>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
            <a-row :gutter="12">
              <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
                <a-form-item>
                  <a-input autocomplete="off"
                    v-decorator="['coa_code2', { rules: [{ required: false }], initialValue: modal.source.data.kode_parent_coa }]"
                    disabled></a-input>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-form-item>
                  <a-input autocomplete="off"
                    v-decorator="['coa_code', { rules: [{ required: true }], initialValue: modal.source.data.kode_coa }]"></a-input>
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <span class="ant-form-item-required">COA Name :</span>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
            <a-form-item>
              <a-input autocomplete="off"
                v-decorator="['coa_name', { rules: [{ required: true }], initialValue: modal.source.data.coa_nm }]"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <span class="ant-form-item-required">COA Group :</span>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
            <a-form-item>
              <a-select showSearch
                v-decorator="['coa_group', { rules: [{ required: true }], initialValue: modal.source.data.coa_group_id }]"
                :filter-option="filterOption">
                <a-select-option v-for="item in mastercoa.coa_group" :key="item.coa_group_id">{{ item.nama_group
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <span class="ant-form-item-required">Tipe :</span>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
            <a-form-item>
              <a-radio-group v-decorator="[
                'tipe',
                {
                  rules: [{ required: true }],
                  initialValue: modal.source.data.isdebet ? modal.source.data.isdebet : '1',
                },
              ]" button-style="solid">
                <a-radio-button value="1"> Debit </a-radio-button>
                <a-radio-button value="0"> Credit </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <span class="ant-form-item-required">Status :</span>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
            <a-form-item>
              <a-radio-group v-decorator="[
                'status',
                {
                  rules: [{ required: true }],
                  initialValue: modal.source.data.aktif_sts ? modal.source.data.aktif_sts : '1',
                },
              ]" :disabled="modal.source.mode == 'Edit'" button-style="solid">
                <a-radio-button value="1"> Active </a-radio-button>
                <a-radio-button value="0"> Non Active </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            Note :
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
            <a-form-item>
              <a-textarea placeholder="Write the note here ... " :rows="4" v-decorator="['note',
                {
                  rules: [{ required: false }],
                  initialValue: modal.source.data.note,
                },]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod";
import _ from "lodash";
export default {
  name: "CreateMasterCoa",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      loading: {
        key: "",
        page: false,
        table: false,
        create: false,
        delete: false,
        savecreate: false,
        saveeditsts: false,
      },
      search: "",
      resources: [],
      resourcesOri: [],
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      columns: [
        {
          title: "#",
          key: "nomor",
          align: "right",
          scopedSlots: { customRender: "nomor" },
          width: 65,
        },
        {
          title: "COA Code",
          key: "kodecoa",
          align: "left",
          scopedSlots: { customRender: "kodecoa" },
          width: 120,
        },
        {
          title: "COA Name",
          key: "namacoa",
          align: "left",
          scopedSlots: { customRender: "namacoa" },
          width: 300,
        },
        {
          title: "COA Parent Code/Name",
          key: "parentcoa",
          align: "left",
          scopedSlots: { customRender: "parentcoa" },
          width: 210,
        },
        {
          title: "Type",
          key: "tipe",
          align: "center",
          scopedSlots: { customRender: "tipe" },
          width: 100,
        },
        {
          title: "Note",
          key: "note",
          align: "left",
          scopedSlots: { customRender: "note" },
          width: 250,
        },
        {
          title: "Active",
          key: "active",
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "active" },
          width: 75,
        },
        {
          title: "Action",
          key: "action",
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
          width: 100,
        },
      ],
      modal: {
        edit: false,
        create: false,
        source: {
          data: [],
          status: false,
          key: "",
          mode: "",
        },
        rules: {
          note: [
            {
              required: true,
              message: "Please input Note",
              trigger: "blur",
            },
          ],
        }
      },
      formEditSts: {
        note: ""
      },
      mastercoa: {
        coa_group: [],
        coa_parent: [],
      },
    };
  },
  beforeCreate() {
    this.formCreate = this.$form.createForm(this);
  },
  mounted() {
    this.getMasterData()
    this.handleReload('page')
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
  },
  methods: {
    handleReloadpage() {
      this.search = ""
      this.handleReload('table')
    },
    async handleReload(type) {
      if (type == "page") {
        this.loading.page = true;
      } else {
        this.loading.table = true;
      }
      await this.asyncAxiosGet("akuntansi/master_coa", this.getAuth, null)
        .then((res) => {
          this.resources = res.data
          for (let i = 0; i < res.data.length; i++) {
            this.resources[i]['Qsearch'] =
              res.data[i].coa_code + " " +
              (res.data[i].kode_parent_coa ? res.data[i].kode_parent_coa : '') + " " +
              (res.data[i].nama_parent_coa ? res.data[i].nama_parent_coa : '') + " " +
              res.data[i].nama_coa;
          }
          this.resourcesOri = this.resources

          this.loading.page = false;
          this.loading.table = false;
        })
        .catch(() => {
          this.loading.page = false;
          this.loading.table = false;
        });
    },
    async getMasterData() {
      await this.asyncAxiosGet("akuntansi/master_coa/master", this.getAuth, null)
        .then((res) => {
          this.mastercoa = res
        })
        .catch(() => {
        });
    },
    moresearch() {
      if (this.search) {
        this.resources = _.filter(this.resourcesOri, (e) =>
          e.Qsearch.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
      } else {
        this.resources = this.resourcesOri
      }
    },
    handletoEdit(key, status) {
      this.modal.source.status = status
      this.modal.source.key = key
      this.formEditSts.note = ""
      this.modal.edit = true;
    },
    handleMeditClose() {
      this.modal.edit = false;
    },
    handleMeditOk() {
      this.$refs.editStsForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        // let idx = _.findIndex(this.resources, (e) => e.key == this.modal.source.key)
        // this.resources[idx].aktif_sts = (this.modal.source.status == "1" ? "0" : "1")
        // this.$refs.editStsForm.resetFields()
        // this.modal.edit = false;

        let paramdata = {
          coa_id: this.modal.source.key,
          status: (this.modal.source.status == "1" ? "0" : "1"),
          note: this.formEditSts.note,
        }
        this.loading.saveeditsts = true;
        this.asyncAxiosPut("akuntansi/master_coa/set_status", "application/json", this.getAuth, paramdata)
          .then(() => {
            //this.formEditSts.resetFields()
            this.loading.saveeditsts = false;
            this.modal.edit = false;
            this.displayMessage("success-edit")
            this.handleReloadpage()
          })
          .catch(() => {
            this.loading.saveeditsts = false;
          });
      })
    },
    handletoCreate(mode, key) {
      if (mode == "Create") {
        this.loading.create = true
      } else {
        this.loading.edit = true
        this.loading.key = key
      }
      this.getMasterData().then(() => {
        this.modal.source.mode = mode
        if (mode == "Edit") {
          this.getMasterData().then(() => {
            this.asyncAxiosGet("akuntansi/master_coa", this.getAuth, { coa_id: key })
              .then((res) => {
                this.modal.source.data = res.data[0]
                if (this.modal.source.data.kode_parent_coa) {
                  this.modal.source.data.kode_coa = this.modal.source.data.kode_coa.substring(
                    this.modal.source.data.kode_parent_coa.length + 1, this.modal.source.data.kode_coa.length)
                  let prn = _.filter(this.mastercoa.coa_parent, (e) => e.coa_id == res.data[0].coa_prn_id)
                  this.modal.source.data.optionPrn = prn[0]
                } else {
                  this.modal.source.data.optionPrn = undefined
                }
                this.loading.create = false
                this.loading.edit = false
                this.loading.key = ""
                this.modal.create = true;
              })
              .catch(() => {
              });
          })
        } else {
          this.modal.source.data = []
          this.modal.create = true;
          this.loading.create = false
          this.loading.edit = false
          this.loading.key = ""
        }
      })
    },
    handleMcreateClose() {
      this.modal.create = false;
    },
    handleMcreateOk() {
      this.formCreate.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        this.loading.savecreate = true

        if (this.modal.source.mode == "Create") {
          let data = new FormData();
          data.append("kode_coa", values.coa_code);
          if (values.coa_parent)
            data.append("coa_parent", values.coa_parent.coa_id);
          data.append("nama_coa", values.coa_name);
          data.append("coa_group", values.coa_group);
          data.append("is_debet", values.tipe);
          data.append("status", values.status);
          data.append("note", values.note ? values.note : "");
          this.asyncAxiosPost("akuntansi/master_coa", "formdata", this.getAuth, data)
            .then(() => {
              this.loading.savecreate = false;
              this.formCreate.resetFields()
              this.modal.create = false;
              this.displayMessage("success-save")
              this.handleReloadpage()
            })
            .catch(() => {
              this.loading.savecreate = false;
            });
        } else {
          let paramdata = {
            coa_id: this.modal.source.data.coa_id,
            kode_coa: values.coa_code,
            coa_parent: values.coa_parent ? values.coa_parent.coa_id : null,
            nama_coa: values.coa_name,
            coa_group: values.coa_group,
            is_debet: values.tipe,
            status: values.status,
            note: values.note ? values.note : ""
          }
          this.asyncAxiosPut("akuntansi/master_coa", "application/json", this.getAuth, paramdata)
            .then(() => {
              this.loading.savecreate = false;
              this.formCreate.resetFields()
              this.modal.create = false;
              this.displayMessage("success-edit")
              this.handleReloadpage()
            })
            .catch(() => {
              this.loading.savecreate = false;
            });
        }
      })
    },
    handletoDel(id) {
      const that = this;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading.delete = true;
          that.loading.key = id;
          that.asyncAxiosDelete(
            "akuntansi/master_coa",
            "application/json",
            that.getAuth,
            { coa_id: id }
          )
            .then((response) => {
              that.loading.delete = false;
              that.loading.key = "";
              if (response.status && response.status == true) {
                that.displayMessageValue("success-other", response.message);
              } else {
                let responses = Object.assign({}, response);
                that.displayMessageValue("error-other", responses);
              }
              that.handleReloadpage()
            })
            .catch(() => {
            });
        },
        onCancel() { },
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    inputVselect(item) {
      this.$nextTick(function () {
        this.formCreate.setFieldsValue({
          coa_code2: item ? item.kode_coa : null,
          coa_parent: item ? item : null
        });
      })
    }
  }
}
</script>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead .ant-table-row-cell-break-word {
  text-align: center !important;
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);

  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border: 1px solid darken(white, 10);
    padding: @padding;
  }

  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &-pertabs {
    height: 30px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border: 1px solid darken(white, 10);
    padding: @padding;
    color: darken(red, 10) !important;
  }
}

.snonaktif {
  color: red
}

.saktif {
  color: green
}

.hiddenOverflow {
  .vs__selected-options {
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
